import React from "react";
import styles from "./Values.module.css";

const values = [
    {
        id: 1,
        icon: "/images/verify.svg",
        title: "Trust & Transparency",
        description: "Every vendor is verified. Every price is upfront. No surprises.",
    },
    {
        id: 2,
        icon: "/images/heart.svg",
        title: "Human-First Service",
        description: "Technology powers us, but people define us. Real humans, real care.",
    },
    {
        id: 3,
        icon: "/images/Group.svg",
        title: "Accessible Luxury",
        description: "Premium concierge services shouldn't be reserved for the few.",
    },
    {
        id: 4,
        icon: "/images/target.svg",
        title: "Reliability",
        description: "SLA-backed tasks with real-time tracking and guaranteed delivery.",
    },
];

function Values() {
    return (
        <section className={styles.section}>

            <div className={styles.heading}>
                <h2>Our Values</h2>
                <p>What drives us every day.</p>
            </div>

            <div className={styles.grid}>
                {values.map((value) => (
                    <div key={value.id} className={styles.card}>
                        <div className={styles.iconWrap}>
                            <img src={value.icon} alt={value.title} />
                        </div>
                        <h3>{value.title}</h3>
                        <p>{value.description}</p>
                    </div>
                ))}
            </div>

        </section>
    );
}

export default Values;